import { z } from 'zod'
import { ADMIN_SERVERS } from '@/lib/servers'

export const PAGE_SIZES = [20, 50, 100] as const

export const listSearchSchema = z.object({
  page: z.number().int().min(1).catch(1).default(1),
  page_size: z
    .number()
    .int()
    .refine((n) => PAGE_SIZES.includes(n as never))
    .catch(20)
    .default(20),
  query: z.string().optional().catch(undefined),
  server: z.enum(ADMIN_SERVERS).optional().catch(undefined),
})

export type ListSearch = z.infer<typeof listSearchSchema>

/**
 * Search box draft to apply when the URL query changes.
 * Returns the URL value when it differs from the last value this field submitted
 * (Clear, then Back). Returns undefined when the URL still matches that submission,
 * so in-progress typing is left alone.
 */
export function searchDraftForUrl(
  urlQuery: string | undefined,
  lastSubmitted: string,
): string | undefined {
  const fromUrl = urlQuery ?? ''
  if (fromUrl === lastSubmitted) return undefined
  return fromUrl
}
